/** DOM id of the gender + preset selection block, used by the hero CTA to
 * scroll-into-view when the user clicks "Create now" before completing setup. */
export const PROFILE_PHOTO_CONFIG_ANCHOR_ID = "profile-photo-config";

/** DOM id of the preset grid block — used for auto-scroll after gender select. */
export const PROFILE_PHOTO_PRESETS_ANCHOR_ID = "profile-photo-presets";

/** DOM id of the hairstyle block — used to scroll the user to the next step
 *  after they finish the custom-style modal. */
export const PROFILE_PHOTO_HAIR_ANCHOR_ID = "profile-photo-hair";

/** DB `pipeline` column value for this flow (server + useGeneratedImages + pending-boost key). */
export const PROFILE_PHOTO_PIPELINE = "profile_photo";
